import { render, staticRenderFns } from "./AtomCheckbox.vue?vue&type=template&id=189cefb8&scoped=true&"
import script from "./AtomCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AtomCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AtomCheckbox.vue?vue&type=style&index=0&id=189cefb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cefb8",
  null
  
)

export default component.exports